
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cashback/ffb",
      function () {
        return require("private-next-pages/cashback/ffb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cashback/ffb"])
      });
    }
  